// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-doc-page-js": () => import("/home/circleci/ui-components-web/packages/ui-components-site/src/templates/doc-page.js" /* webpackChunkName: "component---src-templates-doc-page-js" */)
}

exports.data = () => import("/home/circleci/ui-components-web/packages/ui-components-site/.cache/data.json")

